module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "site-header"
  }, [(_vm.config.title) ? _c('h1', {
    staticClass: "site-title"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.config.title))])], 1) : _vm._e(), _vm._v(" "), (_vm.config.nav) ? _c('ul', {
    staticClass: "site-nav"
  }, _vm._l((_vm.config.nav), function(navItem) {
    return _c('li', [(_vm.isExternalLink(navItem.path)) ? _c('a', {
      attrs: {
        "href": navItem.path,
        "target": "_blank"
      }
    }, [_vm._v("\n        " + _vm._s(navItem.title) + "\n      ")]) : _c('router-link', {
      attrs: {
        "exact": "",
        "to": navItem.path
      }
    }, [_vm._v("\n        " + _vm._s(navItem.title) + "\n      ")])], 1)
  })) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d1971d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1971d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 26
// module chunks = 0